import React from 'react';
import PropTypes from 'prop-types';

import { Column, Row, Container } from '../Layout';

import './index.scss';

export default function Navbar({ Logo, Content, Actions }) {
  return (
    <div className="Navbar__container">
      <Container>
        <Row gutter="l">
          <Column alignSelf="center" wides={[{ wide: 2, breakPoint: 'xs' }]}>
            <div className="Navbar__logo">{Logo}</div>
          </Column>
          <Column wides={[{ wide: 8, breakPoint: 'xs' }]}>
            <div className="Navbar__content">
              {Content.map((c, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={index}>{c}</div>
              ))}
            </div>
          </Column>
          <Column alignSelf="center" wides={[{ wide: 2, breakPoint: 'xs' }]}>
            <div className="Navbar__actions">{Actions}</div>
          </Column>
        </Row>
      </Container>
    </div>
  );
}

Navbar.propTypes = {
  Logo: PropTypes.element,
  Content: PropTypes.node,
  Actions: PropTypes.node,
};

Navbar.defaultProps = {
  Logo: undefined,
  Content: [],
  Actions: [],
};
